/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Button_InjectingInputs */

const en_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating suggestions...`)
};

const de_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschläge werden erstellt...`)
};

const fr_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération des suggestions...`)
};

const es_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando sugerencias...`)
};

const it_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione suggerimenti...`)
};

const nl_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggesties genereren...`)
};

const pl_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generowanie sugestii...`)
};

const fi_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luodaan ehdotuksia...`)
};

const da_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererer forslag...`)
};

const sv_keyword_optimizer_button_injecting = /** @type {(inputs: Keyword_Optimizer_Button_InjectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genererar förslag...`)
};

/**
* | output |
* | --- |
* | "Generating suggestions..." |
*
* @param {Keyword_Optimizer_Button_InjectingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_button_injecting = /** @type {((inputs?: Keyword_Optimizer_Button_InjectingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Button_InjectingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_button_injecting(inputs)
	if (locale === "fr") return fr_keyword_optimizer_button_injecting(inputs)
	if (locale === "es") return es_keyword_optimizer_button_injecting(inputs)
	if (locale === "it") return it_keyword_optimizer_button_injecting(inputs)
	if (locale === "nl") return nl_keyword_optimizer_button_injecting(inputs)
	if (locale === "pl") return pl_keyword_optimizer_button_injecting(inputs)
	if (locale === "fi") return fi_keyword_optimizer_button_injecting(inputs)
	if (locale === "da") return da_keyword_optimizer_button_injecting(inputs)
	if (locale === "sv") return sv_keyword_optimizer_button_injecting(inputs)
	return en_keyword_optimizer_button_injecting(inputs)
});